import React, { useState } from 'react';
import { Credit } from '@indigo-ag/schema';
import { Body, Divider, IconButton, EllipsisLoader } from '@indigo-ag/component-module';
import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons';

export interface PendenciesListProps {
  pendencies?: Credit['pendencies'];
  onUpdatePendencies?: (newPendencies: string[]) => Promise<any>;
  readonly?: boolean;
}

export const PendenciesList: React.FunctionComponent<PendenciesListProps> = ({
  pendencies = [],
  onUpdatePendencies,
  readonly = false
}) => {
  /**
   * State
   */
  const [pendencyDeletedIdx, setPendencyDeletedIdx] = useState<number | null>(null);

  const removePendency = (idx: number) => {
    return () => {
      if (onUpdatePendencies) {
        setPendencyDeletedIdx(idx);
        onUpdatePendencies(pendencies.filter((p, i) => i !== idx)).finally(() => {
          pendencyDeletedIdx && setPendencyDeletedIdx(null);
        });
      }
    };
  };

  return pendencies && pendencies.length ? (
    <div className="width-100">
      {pendencies.map((p, i) => {
        return (
          <div key={`pendency-${i}`}>
            <div style={{ minHeight: 48 }} className="flex flex-space-btw align-items-center mt-3 mb-1">
              <Body className="width-fit-content break-line">{p}</Body>
              {!readonly ? (
                pendencyDeletedIdx === i ? (
                  <div style={{ width: 44 }}>
                    <EllipsisLoader style={{ margin: '0px 10px' }} />
                  </div>
                ) : (
                  <IconButton label="delete" onClick={removePendency(i)} icon={faTrashAlt} busy={true} />
                )
              ) : null}
            </div>
            <Divider />
          </div>
        );
      })}
    </div>
  ) : null;
};
